import { useState, useEffect, useRef } from 'react';

// Using environment variable for the API key
const API_KEY = import.meta.env.VITE_WSX_API_KEY;
const WS_URL = `wss://middleware2.wsx.gr/ws/timetables?key=${API_KEY}`;

export const useTimetableSocket = (socketId) => {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('connecting');
  const [isLoading, setIsLoading] = useState(true);
  const ws = useRef(null);
  const lastSocketId = useRef(null);

  useEffect(() => {
    if (!socketId) return;

    if (lastSocketId.current !== socketId) {
      setIsLoading(true);
      setData([]);
      lastSocketId.current = socketId;
    }

    const connect = () => {
      console.log(`Connecting to socket for ID: ${socketId}`);
      ws.current = new WebSocket(WS_URL);

      ws.current.onopen = () => {
        setStatus('connected');
        ws.current.send(JSON.stringify({ type: 'subscribe', routeId: parseInt(socketId) }));
      };

      ws.current.onmessage = (e) => {
        try {
          const m = JSON.parse(e.data);
          if (m.type === 'timetable' && parseInt(m.routeId) === parseInt(socketId)) {
            const visibleRows = (m.data || []).filter(r => 
              r.eta_time && r.eta_time !== '00:00' && r.eta_time !== '--:--'
            );
            setData(visibleRows);
            setIsLoading(false);
          }
        } catch (err) {
          console.error("Socket parse error:", err);
        }
      };

      ws.current.onclose = () => {
        setStatus('reconnecting');
        setTimeout(() => {
          if (ws.current && ws.current.readyState === WebSocket.CLOSED) {
            connect();
          }
        }, 3000);
      };

      ws.current.onerror = (err) => {
        console.error("Socket error:", err);
        setStatus('error');
      };
    };

    connect();

    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, [socketId]);

  return { data, status, isLoading };
};